import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrerenderLayoutService {
  releasePrerenderLayout() {
    (window as Window & { releasePrerenderLayout?: () => void })
      .releasePrerenderLayout?.();
  }
}
